export const LIST_ORDER_HISTORY = 'LIST_ORDER_HISTORY';
export const DELETE_ORDER_HISTORY = 'DELETE_ORDER_HISTORY';
export const CREATE_ORDER_HISTORY = 'CREATE_ORDER_HISTORY';
export const UPDATE_ORDER_HISTORY = 'UPDATE_ORDER_HISTORY';
export const WS_NEW_ORDER_HISTORY = 'WS_NEW_ORDER_HISTORY';
export const WS_UPDATED_ORDER_HISTORY = 'WS_UPDATED_ORDER_HISTORY';
export const WS_DELETED_ORDER_HISTORY = 'WS_DELETED_ORDER_HISTORY';